export default "__VITE_ASSET___saQHSVY__"